/* eslint-disable no-undef */
import i18n from 'i18next';
import Locize from 'i18next-locize-backend';
import {initReactI18next} from 'react-i18next';

/**
 * Detects the language of an rodenstock page.
 *
 * @class RodenstockLanguageDetector
 */
class RodenstockLanguageDetector {
    /**
     * Creates an instance of RodenstockLanguageDetector.
     *
     * @memberof RodenstockLanguageDetector
     */
    constructor() {
        this.lng = 'de-DE';
    }

    /**
     * Not needed but for i18next
     *
     * @memberof RodenstockLanguageDetector
     */
    init() {/* empty */}

    /**
     * Detects the language.
     *
     * @returns {String} The detected language.
     * @memberof RodenstockLanguageDetector
     */
    detect() {
        if (window.nfqRod) {
            let lang = window.languageID;
            const landCode = window.countryID;

            // TODO: Remove this, after switching to magnolia Translation API with correct da language
            if (lang === 'da') {
                lang = 'dk';
            } else if (lang === 'nl_be') {
                // For Belgium we use the Dutch language
                lang = 'fl';
            }

            return `${lang}-${landCode.toUpperCase()}`;
        }

        return 'de-DE';
    }

    /**
     * Caches the language in the instance.
     *
     * @param {String} lng Detected language.
     * @memberof RodenstockLanguageDetector
     */
    cacheUserLanguage(lng) {
        this.lng = lng;
    }
}

RodenstockLanguageDetector.type = 'languageDetector';

const load = new Promise(function(resolve) {
    i18n
        .use(Locize)
        .use(initReactI18next)
        .use(RodenstockLanguageDetector)
        .init({
            //saveMissing: TRANSLATE_DEBUG,
            //updateMissing: TRANSLATE_DEBUG,
            fallbackLng: 'en',
            debug: TRANSLATE_DEBUG,
            // lng: 'de-DE',
            backend: {
                projectId: 'aee37ce3-7d35-4a3d-b61d-6fcce3749a48',
                apiKey: TRANSLATE_API_KEY,
                referenceLng: 'en',
                version: TRANSLATE_VERSION,
                //allowedAddOrUpdateHosts: ['localhost', '127.0.0.1']
            },
            ns: ['common'],
            defaultNS: 'common',
            saveMissingTo: 'common',
            interpolation: {escapeValue: false},
            react: {useSuspense: false}
        }, function() {
            resolve();
        });
});

export default load;